(function(algolia) {
  'use strict';
  algolia.translations = {
    search: window.algoliaTranslations.search,
    noCollectionFound: window.algoliaTranslations.noCollectionFound,
    allProducts: window.algoliaTranslations.allProducts,
    matching: window.algoliaTranslations.matching,
    sortBy: window.algoliaTranslations.sortBy,
    relevance: window.algoliaTranslations.relevance,
    outOf: window.algoliaTranslations.outOf,
    resultsFound: window.algoliaTranslations.resultsFound,
    oneResultFound: window.algoliaTranslations.oneResultFound,
    noResultFound: window.algoliaTranslations.noResultFound,
    addToCart: window.algoliaTranslations.addToCart,
    searchForProduct: window.algoliaTranslations.searchForProduct,
    selectedFilter: window.algoliaTranslations.selectedFilter,
    clearAll: window.algoliaTranslations.clearAll,
    noPageFound: window.algoliaTranslations.noPageFound,
    outOfStock: window.algoliaTranslations.outOfStock,
    kosher: window.algoliaTranslations.kosher,
    organic: window.algoliaTranslations.organic,
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return window.algoliaTranslations.noResultForQuery + ' ' + render(text);
    },
    in: function() {
      return window.algoliaTranslations.in + ' ' + this.processingTimeMS / 1000 + 's';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        window.algoliaTranslations.try + ' ' +
        render(html_tags[0]) +
        ' ' + window.algoliaTranslations.clearingFilters + ' ' +
        render(html_tags[1]) +
        ' ' + window.algoliaTranslations.or + ' ' +
        render(html_tags[2]) +
        ' ' + window.algoliaTranslations.changingYourInput + ' ' +
        render(html_tags[3])
      );
    },

    outOf: function() {
      return (
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        ' ' + window.algoliaTranslations.outOf
      );
    },

    by: function(text, render) {
      return window.algoliaTranslations.by + ' ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
